<div class="article-tab">
  <!-- Let's work on your content card -->
  <div class="work-on-content-card">
    <h2 class="card-heading">Let's work on your content</h2>
    <div class="action-buttons">
      <button
        mat-stroked-button
        type="button"
        class="pill-btn toggle-create-btn"
        [class.toggle-create-active]="createNewSelected"
        (click)="toggleCreateNew()">
        <mat-icon>edit</mat-icon>
        Create New Article
      </button>
      <button mat-stroked-button type="button" class="pill-btn pill-btn-with-soon" disabled aria-disabled="true">
        <span class="pill-btn-row">
          <mat-icon>auto_awesome</mat-icon>
          <span class="pill-btn-label">Optimize for AI search</span>
        </span>
        <span class="pill-btn-soon">coming soon</span>
      </button>
      <button mat-stroked-button type="button" class="pill-btn pill-btn-with-soon" disabled aria-disabled="true">
        <span class="pill-btn-row">
          <mat-icon>refresh</mat-icon>
          <span class="pill-btn-label">Repurpose article</span>
        </span>
        <span class="pill-btn-soon">coming soon</span>
      </button>
    </div>
    <div class="command-bar">
      <input
        type="text"
        class="command-input"
        placeholder="Article title or topic"
        [(ngModel)]="commandBarInput"
        (keydown.enter)="canProceedFromCommandBar && onCommandBarSubmit()"
      />
      <button
        mat-icon-button
        color="primary"
        class="command-bar-arrow"
        [disabled]="!canProceedFromCommandBar"
        (click)="onCommandBarSubmit()"
        title="Continue to article setup (enter a title or topic first)">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    <!-- @if (!canProceedFromCommandBar) {
      <p class="command-hint">Enter a title or topic above, then use the arrow to continue.</p>
    } -->
  </div>

  <!-- History -->
  <div class="history-section">
    <h3 class="history-title">Article history</h3>
    @if (historyLoading) {
      <div class="history-loading">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Loading history…</span>
      </div>
    } @else if (historyError) {
      <div class="history-error">{{ historyError }}</div>
    } @else if (!projectId) {
      <p class="history-empty">Select a project to see article history.</p>
    } @else if (historyItems.length === 0) {
      <p class="history-empty">No articles yet. Create your first article above.</p>
    } @else {
      <div class="history-table-wrapper">
        <table mat-table [dataSource]="historyItems" class="history-table">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let row">{{ row.title }}</td>
          </ng-container>
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let row">{{ formatDate(row.created_at) }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" (click)="showArticle(row)">Show article</button>
              <button mat-button (click)="downloadArticle(row)">
                <mat-icon>download</mat-icon>
                Download
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['title', 'created_at', 'actions']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['title', 'created_at', 'actions']"></tr>
        </table>
      </div>
    }
  </div>
</div>
